import React from 'react';
import { useTranslation } from 'react-i18next';
import Hint from './hint';

interface Props {
  onClick: (doamin: string) => void;
  domain: string;
  className: string;
}

const TEXT_TRANSLATION_KEY = 'signup-flow.domain.free.hint.tld_detected.text';
const CTA_TRANSLATION_KEY = 'signup-flow.domain.free.hint.tld_detected.cta';

const onHintClick = (props: Props) => () => {
  props.onClick(props.domain);
};

const FreeTldDetectedHint: React.SFC<Props> = (props) => {
  const { t } = useTranslation();

  const text = t(TEXT_TRANSLATION_KEY).replace('{DOMAIN}', props.domain);
  const ctaText = t(CTA_TRANSLATION_KEY);

  return (
    <Hint
      className={props.className}
      html={text}
      ctaText={ctaText}
      onClick={onHintClick(props)}
    />
  );
};

export default FreeTldDetectedHint;
